import { useEffect, useState, useMemo } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFAutocomplete, RHFSelect, RHFTextField } from 'src/components/hook-form';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { formatDate, handleErrorMessages } from '../../risk-register/feching';
import Iconify from 'src/components/iconify';
import { DatePicker } from '@mui/x-date-pickers';
import EmployeeUserAdd from './employe-drop-down';
import DropDownAddValueCustom from './../../../drop-down-add-value/drop-down-add-new-stage';
import BankInfoInstantCreate from '../bank-information/bank-info-instant-create';

const ExpensesCreate = ({
  open,
  onClose,
  reload,
  currentItem,
  closeform,
  employeeOptions,
  departmentsOptions,
  categoryOptions,
  subCategoryOptions,
  getSubCat,
  createdby,
  vendorsList,
  projectList,
  costcenterList,
  chartsAccountList,
  customerList,
  relaodCatgeory,
  relaodDepartments,
  relaodCostCenter,
}) => {
  console.log('🚀 ~ currentItem:', currentItem);
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [subCatReload, setSubCatReload] = useState(false);
  const [charges, setcharges] = useState('Billable');
  const [type, setType] = useState('expense');
  const [debitcreadit, setdebitcreadit] = useState('Debit');
  const [bankInformation, setBankInformation] = useState([]);
  const [catId, setCatId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const expenseTypeOptions = [
    { id: 1, name: 'none' },
    { id: 2, name: 'Travel Expense' },
    { id: 3, name: 'Office Supplies' },
    { id: 4, name: 'Meals and Entertainment' },
    { id: 5, name: 'Training & Education' },
    { id: 6, name: 'Rent & Utilities' },
    { id: 7, name: 'Equipment Maintenance' },
    { id: 8, name: 'Material Maintenance' },
    { id: 9, name: 'Other' },
  ];

  const NewUserSchema = Yup.object().shape({
    date: Yup.date().required('Date is required').typeError('Invalid date format'),

    amount: Yup.number()
      .required('Amount is required')
      .typeError('Amount must be a number')
      .min(0.01, 'Amount must be greater than 0'),

    description: Yup.string()
      .required('Expense description is required')
      .min(3, 'Description must be at least 3 characters')
      .max(255, 'Description must be at most 255 characters'),

    // type: Yup.string().required('Type is required'),

    // vendor_id: Yup.object()
    //   .shape({
    //     id: Yup.string().required('Vendor is required'),
    //     name: Yup.string().required('Vendor name is required'),
    //   })
    //   .nullable()
    //   .when('type', {
    //     is: 'expense',
    //     then: (schema) => schema.required('Vendor is required'),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),

    // customer_id: Yup.object()
    //   .shape({
    //     id: Yup.string().required('Customer is required'),
    //     name: Yup.string().required('Customer name is required'),
    //   })
    //   .nullable()
    //   .when('type', {
    //     is: 'income',
    //     then: (schema) => schema.required('Customer is required'),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),
  });

  //const defaultValues = useMemo(
  //    () => ({
  //        date: currentItem?.date ? new Date(currentItem.date) : new Date(),
  //        company_name: currentItem?.company_name || '',
  //        project_id: currentItem?.project || '',
  //        description: currentItem?.description || '',
  //        payment_method: currentItem?.payment_method || '',
  //        credit: currentItem?.credit || '',
  //        debit: currentItem?.debit || '',
  //        charges: currentItem?.charges || '',
  //        employee_id: currentItem?.employee?.id || '',
  //        department_id: currentItem?.department_id || '',
  //        expense_category_id: currentItem?.expense_category_id || '',
  //        expense_subcategory_id: currentItem?.expense_subcategory_id || '',
  //        account_chart_id: currentItem?.account_chart_id || '',
  //        financial_statement: currentItem?.financial_statement || '',
  //        cost_center_id: currentItem?.cost_center_id || '',
  //        receipt: currentItem?.receipt || null,
  //        amount: currentItem?.amount || '',
  //        tax_code: currentItem?.tax_code || '',
  //        expense_type: currentItem?.expense_type || '',
  //        approval_required: currentItem?.approval_required || '',
  //        status: currentItem?.status || '',
  //        notes: currentItem?.notes || '',
  //    }),
  //    [currentItem]
  //);

  const defaultValues = useMemo(() => {
    const amount = currentItem?.credit
      ? parseFloat(currentItem.credit)
      : currentItem?.debit
      ? parseFloat(currentItem.debit)
      : ''; // Determine the amount based on credit/debit

    return {
      date: currentItem?.date ? new Date(currentItem.date) : new Date(),
      company_name: currentItem?.company_name || '',
      project_id: currentItem?.project || '',
      bank_information_id: currentItem?.bankInformation || '',
      vendor_id: currentItem?.vendor || null,
      employee_id: currentItem?.employee || null, // Set full employee object
      description: currentItem?.description || '',
      payment_method: currentItem?.payment_method || '',
      credit: currentItem?.credit || '',
      debit: currentItem?.debit || '',
      charges: currentItem?.charges || 'Billable', // Default to 'Billable' if not provided
      department_id: currentItem?.department || '',
      expense_category_id: currentItem?.category || '',
      expense_subcategory_id: currentItem?.subcategory || '',
      account_chart_id: currentItem?.account_chart || '',
      financial_statement: currentItem?.financial_statement || '',
      cost_center_id: currentItem?.cost_center || '',
      receipt: currentItem?.receipt || null,
      amount: amount, // Dynamically set based on credit/debit
      tax_code: currentItem?.tax_code || '',
      expense_type: currentItem?.expense_type || null,
      approval_required: (currentItem?.approval_required === 0 ? { id: 0, label: 'No' } : { id: 1, label: 'Yes' }) || null,
      status: (currentItem?.status === 0 ? { id: 0, label: 'No' } : { id: 1, label: 'Yes' }) || null , // Default to '0' (No) if not provided
      notes: currentItem?.notes || '',
    };
  }, [currentItem]);

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });
  const {
    reset,
    setValue,
    control,
    clearErrors,
    watch,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    setValue('vendor_id', '');
    setValue('customer_id', '');
  }, [type]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setValue('expense_subcategory_id', currentItem?.subcategory || '');
    }, 2000);

    return () => clearTimeout(timer); // Cleanup to avoid memory leaks
  }, [currentItem, setValue]);

  useEffect(()=>{
    if (
      currentItem?.department || 
      currentItem?.category || 
      currentItem?.subcategory || 
      currentItem?.account_chart || 
      currentItem?.financial_statement || 
      currentItem?.cost_center || 
      currentItem?.tax_code || 
      currentItem?.expense_type || 
      currentItem?.approval_required || 
      currentItem?.status || 
      currentItem?.notes
    ) {
      setIsChecked(true)
    }
  },[currentItem?.id])

  const selectedChart = watch('account_chart_id'); // Watching the `payment_method` field
  const selectedCat = watch('expense_category_id'); // Watching the `payment_method` field

  useEffect(() => {
    setValue('expense_subcategory_id', '');
  }, [selectedCat]);

  useEffect(() => {
    if (selectedChart) {
      const { name, account_type } = selectedChart;
      setValue('charts_of_description', name || '');
      setValue('account_type_id', account_type?.name || '');
    } else {
      setValue('charts_of_description', '');
      setValue('account_type_id', '');
    }
  }, [selectedChart, setValue]);

  useEffect(() => {
    reset(defaultValues);
  }, [currentItem, reset, defaultValues]);

  useEffect(() => {
    if(!currentItem?.id){
      setIsChecked(false);
    }
  }, [isOpen, currentItem?.id]);

  const getBankInformation = async () => {
    const data = await getRequest(endpoints.accounting.bank_information.get_list);
    if (data) {
      setBankInformation(data);
    }
  };

  const handleOpen = (e) => {
    e.stopPropagation(); // Prevent the parent form from submitting
    setIsOpen(true);
  };

  useEffect(() => {
    getProfile();
    getBankInformation();
  }, []);
  const getProfile = async () => {
    try {
      const data = await getRequest(endpoints.profile_info);
      setCompanyName(data.company_name || '');
    } catch (error) {
      console.error('Error fetching profile: ', error);
    }
  };
  useEffect(() => {
    setValue('company_name', companyName);
  }, [companyName, setValue, open]);

  let approvalOptions = [
    { id: 1, label: 'Yes' },
    { id: 0, label: 'No' },
  ];

  const time = new Date().toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const closeAndReset = () => {
    onClose();
    reset(defaultValues);
    if(!currentItem?.id){
      setIsChecked(false);
    }
  };
  const onSubmit = handleSubmit(async (data) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('date', `${formatDate(data.date)} ${time}`);
    formData.append('company_name', data.company_name);
    formData.append('project_id', data.project_id.id || null);
    formData.append('employee_id', data?.employee_id || null);
    formData.append('bank_information_id', data.bank_information_id?.id || '');
    // formData.append('description', data.description);
    formData.append('payment_method', data.payment_method);
    formData.append('entry_type', type);
    // formData.append('approval_required', data?.approval_required?.id);
    // formData.append('status', data?.status?.id);
    // formData.append('notes', data.notes);
    // formData.append('account_chart_id', data.account_chart_id?.id || '');
    if (debitcreadit === 'Credit') {
      formData.append('credit', data.amount || 0);
      formData.append('debit', '');
    } else if (debitcreadit === 'Debit') {
      formData.append('debit', data.amount || 0);
      formData.append('credit', '');
    } else {
      enqueueSnackbar({
        variant: 'error',
        message: 'Please select either Credit or Debit.',
      });
      setLoading(false);
      return;
    }

    formData.append('charges', data.charges); // Expense Type
    type === 'expense'
      ? formData.append('vendor_id', data?.vendor_id?.id || null)
      : formData.append('customer_id', data?.customer_id?.id);

    if (data.receipt) {
      formData.append('receipt', data.receipt[0]);
    }

    if (isChecked) {
      formData.append('department_id', data?.department_id?.id);
      formData.append('expense_category_id', data?.expense_category_id?.id);
      formData.append('expense_subcategory_id', data?.expense_subcategory_id?.id);
      formData.append('account_chart_id', data?.account_chart_id?.id);
      formData.append('description', data?.description);
      // formData.append('account_type_id', data?.account_type?.id);
      formData.append('financial_statement', data?.financial_statement);
      formData.append('cost_center_id', data?.cost_center_id?.id);
      formData.append('tax_code', data?.tax_code);
      formData.append('expense_type_id', data?.expense_type?.id);
      formData.append('approval_required', data?.approval_required?.id);
      formData.append('status', data?.status?.id);
      formData.append('notes', data?.notes);
    }

    try {
      const response = await postRequest(
        currentItem?.id
          ? `${endpoints.accounting.expenses.post_list}/${currentItem.id}?_method=PUT`
          : endpoints.accounting.expenses.post_list,
        formData,
        true
      );
      if (response.metadata && response.metadata.success) {
        reset();
        onClose();
        closeform();
        reload();
        enqueueSnackbar({
          variant: 'success',
          message: response.metadata.message,
        });
      } else {
        handleErrorMessages(response?.message || 'An error occurred.');
      }
    } catch (err) {
      handleErrorMessages(err.message || 'Submission failed.');
    } finally {
      setLoading(false);
    }
  });

  const cahrgesOptions = [
    { label: 'Billable', value: 'Billable' },
    { label: 'Non-Billable ', value: 'Non-Billable ' },
  ];

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    if (!currentItem?.id) {
      const fields = [
        'department_id',
        'expense_category_id',
        'expense_subcategory_id',
        'account_chart_id',
        'description',
        'financial_statement',
        'cost_center_id',
        'tax_code',
        'expense_type_id',
        'approval_required',
        'status',
        'notes',
      ];

      fields.forEach((field) => setValue(field, ''));
    }
  };
  const handleType = (e) => {
    setType(e.target.value);
  };
  const paymentMethod = watch('payment_method');

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          closeAndReset();
        }
      }}
      fullWidth
      maxWidth="md"
      sx={{
        borderRadius: 'none',
        padding: '60px',
        fontSize: '13px',
        fontFamily: 'arial',
      }}
      transitionDuration={{
        enter: theme.transitions.duration.shortest,
        exit: theme.transitions.duration.shortest - 80,
      }}
    >
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <span
              className="cardColor"
              style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}
            >
              &nbsp;&nbsp; Expenses &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </Box>
          <IconButton onClick={closeAndReset}>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            borderRadius: '1px',
          }}
        >
          <RHFSelect
            name="entry_type"
            value={type}
            sx={{
              width: '105px',
              height: '40px',
              '& .MuiInputBase-root': { height: '40px', marginTop: '2px' },
            }}
            onChange={handleType}
          >
            <MenuItem value="expense">Expense</MenuItem>
            <MenuItem value="income">Income</MenuItem>
          </RHFSelect>
          <h2>Base Fields</h2>
          <Divider />
          <Box
            mt={2}
            rowGap={3}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
            }}
          >
            <Controller
              name="date"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <DatePicker
                  label={`Date ${error ? '*' : ''}`}
                  value={field.value}
                  onChange={(newValue) => {
                    field.onChange(newValue);
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!error,
                      helperText: error?.message,
                    },
                  }}
                />
              )}
            />
            <RHFTextField name="company_name" label="Company Name" disabled />
            <RHFAutocomplete
              name="project_id"
              label="Project Name"
              options={projectList}
              getOptionLabel={(option) => option?.name || ''}
              isOptionEqualToValue={(option, value) => option === value}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.name}
                </li>
              )}
            />

            <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
              <RHFAutocomplete
                sx={{ width: '100%' }}
                name="bank_information_id"
                label="Name of Bank"
                options={bankInformation}
                onChange={(_, value) => {
                  setValue('bank_information_id', value);
                  clearErrors('bank_information_id');
                }}
                getOptionLabel={(option) => option?.bank_name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.bank_name}
                  </li>
                )}
              />
              <IconButton
                onClick={handleOpen}
                className="cardColor"
                sx={{
                  margin: '5px 10px',

                  color: '#FFF',
                  fontSize: 25,
                  padding: '7px',
                  borderRadius: '50%',
                  '&:hover': {
                    backgroundColor: '#7AB13A',
                  },
                  boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
                }}
              >
                <Iconify icon="mingcute:add-line" />
              </IconButton>
            </Box>

            <RHFTextField name="description" label="Expenses / Income Description" />
            {paymentMethod === 'Credit Card' ? (
              <RHFTextField name="amount" label="Amount" type="number" />
            ) : (
              <RHFTextField name="amount" label=" Amount" type="number" />
            )}
            <RHFAutocomplete
              name="payment_method"
              label="Payment Method"
              options={[
                'Cash',
                'Cheque',
                'Credit Card',
                'Bank Transfer',
                'Debit Card',
                'Mobile Pameent(eg, PayPal,Venmo)',
              ]}
              getOptionLabel={(option) => option}
              isOptionEqualToValue={(option, value) => option === value}
              renderOption={(props, option) => (
                <li {...props} key={option}>
                  {option}
                </li>
              )}
              error={!!methods.formState.errors.approval_status}
              helperText={methods.formState.errors.approval_status?.message}
            />
            <RHFAutocomplete
              name="credit"
              label="Credit/Debit"
              options={['Credit', 'Debit']}
              getOptionLabel={(option) => option}
              isOptionEqualToValue={(option, value) => option === value}
              renderOption={(props, option) => (
                <li {...props} key={option}>
                  {option}
                </li>
              )}
              value={debitcreadit}
              onChange={(_, value) => {
                setdebitcreadit(value); // Update state
                methods.setValue('credit', value); // Update React Hook Form value
              }}
              error={!!methods.formState.errors.credit}
              helperText={methods.formState.errors.credit?.message}
            />

            <RHFAutocomplete
              name="charges"
              label="Charges"
              options={cahrgesOptions}
              value={cahrgesOptions.find((option) => option.value === charges)}
              getOptionLabel={(option) => option?.label || ''}
              onChange={(e, value) => setcharges(value ? value.value : '')}
            />

            {type === 'expense' ? (
              <RHFAutocomplete
                name="vendor_id"
                label="Vendor Name"
                options={vendorsList}
                getOptionLabel={(option) => option?.name || ''}
                isOptionEqualToValue={(option, value) => option?.id === value?.id} // Compare by id
                value={watch('vendor_id')}
                renderOption={(props, option) =>
                  option?.name ? (
                    <li {...props} key={option.id}>
                      {option.name}
                    </li>
                  ) : null
                }
                onChange={(_, value) => {
                  setValue('vendor_id', value || null);
                  clearErrors('vendor_id');
                }}
                error={!!methods.formState.errors.vendor_id}
                helperText={methods.formState.errors.vendor_id?.message}
              />
            ) : (
              <RHFAutocomplete
                name="customer_id"
                label="Customer List"
                options={customerList}
                getOptionLabel={(option) => option?.name || ''}
                isOptionEqualToValue={(option, value) => option?.name === value?.name}
                renderOption={(props, option) =>
                  option?.name ? (
                    <li {...props} key={option.name}>
                      {option.name}
                    </li>
                  ) : null
                }
              />
            )}

            <div>
              <div>
                <input
                  type="file"
                  name="receipt"
                  label="Receipt"
                  className="form-control"
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '8px',
                    fontSize: '14px',
                    marginTop: '0px',
                    width: '400px',
                    height: '50px',
                  }}
                  onChange={(e) => setValue('receipt', e.target.files)} // Update form value with selected file
                />
              </div>
            </div>
            <EmployeeUserAdd
              name="employee_name"
              label="Employee Name"
              set={setValue}
              options={employeeOptions}
              // reload={() => reloadRiskOwnersOptions()}
              //url={endpoints.risk_management.risk_register.identification.risk_owners}
              // onRiskOwnerChange={handleOwnerChange}
              // onChange={handleOwnerChange}
              value={currentItem?.employee?.id}
            />
            {/*<RHFAutocomplete
                            name="employee_id"
                            label="Paid by"
                            options={createdby}
                            getOptionLabel={(option) => option?.name || ''}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => <li {...props} key={option.id}>{option.name}</li>}
                        />*/}
          </Box>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginTop: '35px',
              marginLeft: '25px',
            }}
          >
            <span
              style={{
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Additional Information
            </span>
            <input
              type="checkbox"
              style={{ width: '16px', height: '16px' }}
              onChange={handleCheckboxChange}
              checked={isChecked}
            />
          </div>
          {isChecked && (
            <>
              <Box
                mt={2}
                rowGap={3}
                columnGap={2}
                display="grid"
                style={{ marginTop: '10px' }}
                gridTemplateColumns={{
                  xs: 'repeat(1, 1fr)',
                  sm: 'repeat(2, 1fr)',
                }}
              >
                <RHFTextField name="employee_ids" label="Employee ID" type="number" />
                <DropDownAddValueCustom
                  name="department_id"
                  label={`Department ${methods.formState.errors.project_stage ? '*' : ''}`}
                  options={departmentsOptions}
                  onChange={(selectedOption) => {
                    methods.setValue('department_id', Number(selectedOption || ''));
                  }}
                  url={endpoints.accounting.expenses.add_departments_list}
                  reload={() => relaodDepartments()}
                />
                <DropDownAddValueCustom
                  name="expense_category_id"
                  cat={selectedCat}
                  setCatId={setCatId}
                  subCatReload={subCatReload}
                  getSubCat={getSubCat}
                  label={`Category ${methods.formState.errors.project_stage ? '*' : ''}`}
                  options={categoryOptions}
                  onChange={(selectedOption) => {
                    methods.setValue('expense_category_id', Number(selectedOption?.id || 0));
                  }}
                  url={endpoints.accounting.expenses.add_category_list}
                  reload={() => relaodCatgeory()}
                />
                <DropDownAddValueCustom
                  name="expense_subcategory_id"
                  label={`Sub Category ${methods.formState.errors.project_stage ? '*' : ''}`}
                  cat={selectedCat}
                  options={subCategoryOptions}
                  onChange={(selectedOption) => {
                    methods.setValue('expense_subcategory_id', Number(selectedOption?.id || 0));
                  }}
                  url={`${endpoints?.accounting?.expenses?.add_sub_category_list}/${catId}/subcategories`}
                  reload={() => setSubCatReload(true)}
                />
                <RHFAutocomplete
                  name="account_chart_id"
                  label="Charts of Account"
                  options={chartsAccountList.filter((option) => option?.code && option?.name)} // Filter out undefined or empty options
                  getOptionLabel={(option) =>
                    option?.code && option?.name ? `${option.code} - ${option.name}` : ''
                  } // Show "Empty" if no value
                  isOptionEqualToValue={(option, value) => option?.code === value?.code}
                  renderOption={(props, option) =>
                    option?.code ? (
                      <li {...props} key={option.code}>
                        {option.code} - {option.name}
                      </li>
                    ) : null
                  }
                  onChange={(_, value) => {
                    methods.setValue('charts_of_description', value?.description || '');
                    methods.setValue('account_type_id', value?.accountType || '');
                    methods.setValue('account_chart_id', value || null);
                  }}
                  error={!!methods.formState.errors.account_chart_id}
                  helperText={methods.formState.errors.account_chart_id?.message}
                />

                <RHFTextField
                  name="charts_of_description"
                  label="Charts of Description"
                  InputLabelProps={{
                    shrink: true, // Ensures the label remains active (floating above the input)
                  }}
                />
                <RHFTextField
                  name="account_type_id"
                  label="Account Type"
                  InputLabelProps={{
                    shrink: true, // Ensures the label remains active (floating above the input)
                  }}
                />

                <RHFTextField name="financial_statement" label="Financial Statement" />
                <DropDownAddValueCustom
                  name="cost_center_id"
                  label={`Cost Center (if Applicable) ${
                    methods.formState.errors.project_stage ? '*' : ''
                  }`}
                  options={costcenterList}
                  onChange={(selectedOption) => {
                    methods.setValue('cost_center_id', Number(selectedOption?.id || 0));
                  }}
                  url={endpoints.accounting.expenses.add_cost_center_list}
                  reload={() => relaodCostCenter()}
                />

                <RHFTextField name="tax_code" label="Tax Code" />
                <RHFAutocomplete
                  name="expense_type"
                  label="Expense Type"
                  options={expenseTypeOptions}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  renderOption={(props, option) => (
                    <li {...props} key={option?.id}>
                      {option?.name}
                    </li>
                  )}
                  error={!!methods.formState.errors.approval_status}
                  helperText={methods.formState.errors.approval_status?.message}
                />
                <RHFAutocomplete
                  name="approval_required"
                  label="Approval Required"
                  options={approvalOptions}
                  getOptionLabel={(option) => option?.label || ''}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.label}
                    </li>
                  )}
                  // onChange={(_, value) => {
                  //     methods.setValue('approval_required', value?.id); // Pass the ID
                  // }}
                  // value={methods.getValues('approval_required') || null}
                  error={!!methods.formState.errors.approval_required}
                  helperText={methods.formState.errors.approval_required?.message}
                />

                <RHFAutocomplete
                  name="status"
                  label="Status"
                  options={[
                    { id: 1, label: 'Yes' },
                    { id: 0, label: 'No' },
                  ]}
                  getOptionLabel={(option) => option?.label || ''}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.label}
                    </li>
                  )}
                  // onChange={(_, value) => {
                  //     methods.setValue('status', value?.id); // Pass the ID
                  // }}
                  // value={methods.getValues('status') || null}
                  error={!!methods.formState.errors.status}
                  helperText={methods.formState.errors.status?.message}
                />
              </Box>

              <Box style={{ marginTop: '10px' }}>
                <RHFTextField name="notes" label="Notes/Remarks" multiline rows={4} />
              </Box>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={closeAndReset}>
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            className="dark-button"
            loading={isSubmitting}
          >
            {currentItem.id ? 'Upadte' : 'Submit'}
          </LoadingButton>
        </DialogActions>
      </FormProvider>
      
      <BankInfoInstantCreate
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        reloadBankInfo={() => getBankInformation()}
      />
    </Dialog>
  );
};
export default ExpensesCreate;
